import { BusinessDetails } from "../../models/business-details.models";
import { Business } from "../../models/business.model";
import { City } from "../../models/city.models";
import { ContactDetails } from "../../models/contact-details.model";
import { InsureItems } from "../../models/insure-items.model";
import { AllAPIResponseStatus } from "../../models/util.model";

export interface SharedState {
    all_api_respons_status: AllAPIResponseStatus,
    enquiry_id?: string,
    loading: boolean;
    quote_data: {
        contact_details: ContactDetails,
        business_details: BusinessDetails,
        insure_items: InsureItems
    };
    city_list: City[],
    business_list: Business[]
}

export const initialState: SharedState = {
    all_api_respons_status: {
        get_pre_quote_data: false,
        save_pre_quote_data: false,
        update_pre_quote_data: false,
    },
    enquiry_id: undefined,
    loading: false,
    quote_data: {
        contact_details: {
            company_name: "",
            mobile_no: "",
            email_id: "",
            city: "",
            city_id: 0
        },
        business_details: {
            insurance_type: "",
            business_type: "",
            business_id: 0,
            owner_type: ""
        },
        insure_items: {
            building: {
                is_select: false,
                building_value: 0
            },
            content: {
                is_select: false,
                plant_and_machinery_value: 0,
                furniture_and_fixtures_value: 0,
                other_content_value: 0
            },
            stock: {
                is_select: false,
                raw_material_value: 0,
                in_process_stock_value: 0,
                finished_stock_value: 0
            }
        }
    },
    city_list: [],
    business_list: []
}